export enum Events {
	RestoreFileChannel = 'urn:event:file:restore',
	DeleteFileChannel = 'urn:event:file:delete',
	PreviewFileChannel = 'urn:event:file:preview',
	SelectedFileChannel = 'urn:event:file:selected',
	RenameFileChannel = 'urn:event:file:rename',
	UploadFileStartChannel = 'urn:event:file:upload-start',
	UploadFileCompleteChannel = 'urn:event:file:upload-complete',
	UploadFileCancelChannel = 'urn:event:file:upload-cancel',
	DownloadFileChannel = 'urn:event:file:download',
	PermanentDeleteFileChannel = 'urn:event:file:delete-permanent',
	CountUpdated = 'urn:event:file:count-updated',
	CreateFolderChannel = 'urn:event:file:folder-create',
	LinkToContainerChannel = 'urn:event:resource:link',
	UnLinkToContainerChannel = 'urn:event:resource:unlink',
	MoveFileChannel = 'urn:event:file:move',
	CopyFileChannel = 'urn:event:file:copy',
	AddOrEditDescriptionChannel = 'urn:event:file:add-or-edit-description',
}
